import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';
import SoftButton from 'components/SoftButton';
import SoftInput from 'components/SoftInput';
import SoftTypography from 'components/SoftTypography';
import Grid from '@mui/material/Grid';
import Swal from 'sweetalert2';
import axios from 'axios';
import { useParams } from 'react-router-dom';

import DocumentTypeSelector from 'components/DocumentTypeSelector';

const ShipmentEditDocumentModal = ({ open, handleClose, initialData, onRefresh }) => {
  // Extraemos el idOrdenDetalle desde la URL
  const { idOrdenDetalle } = useParams();

  // Incluimos id_detalle en el estado (para usarlo en la generación del nuevo nombre de archivo, si fuera necesario)
  const [formData, setFormData] = useState({
    nombreDocumento: '',
    not: '',          // Nota del documento (se llamará 'not' para el endpoint)
    tip: '',          // Tipo de documento (se llamará 'tip')
    id_detalle: '',
  });

  useEffect(() => {
    if (initialData) {
      setFormData({
        nombreDocumento: initialData.nombre || '',
        not: initialData.nota || '',
        tip: initialData.tipo || '',
        id_detalle: idOrdenDetalle, // asignamos el idOrdenDetalle a id_detalle
      });
    } else {
      setFormData({
        nombreDocumento: '',
        not: '',
        tip: '',
        id_detalle: idOrdenDetalle,
      });
    }
  }, [initialData, open, idOrdenDetalle]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  // Se usa DocumentTypeSelector para actualizar el campo 'tip'
  const handleSave = () => {
    if (!formData.nombreDocumento || !formData.not || !formData.tip) {
      Swal.fire({
        icon: 'error',
        title: 'Campos incompletos',
        text: 'Por favor complete todos los campos.'
      });
      return;
    }

    // Enviar al endpoint de embarques usando PATCH, transformando las claves para que coincidan con el backend
    axios
      .patch(`${process.env.REACT_APP_SERVER_URL}/api/orders/shipments-documents/${initialData.id_documentos}/`, {
        nombreDocumento: formData.nombreDocumento,
        not: formData.not,
        tip: formData.tip,
        id_detalle: formData.id_detalle
      })
      .then((response) => {
        Swal.fire({
          icon: 'success',
          title: 'Actualizado',
          text: 'El documento ha sido actualizado correctamente!'
        });
        handleClose();
        if (onRefresh) onRefresh();
      })
      .catch((error) => {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Error al actualizar el documento. Inténtelo nuevamente.'
        });
        console.error("Error updating shipment document:", error);
      });
  };

  return (
    <Modal show={open} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Editar Documento de Embarque</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <SoftTypography variant="caption" fontWeight="bold" color="text">
              Nombre del documento
            </SoftTypography>
            <SoftInput
              type="text"
              name="nombreDocumento"
              placeholder="Ingrese el nombre del documento"
              value={formData.nombreDocumento}
              onChange={handleInputChange}
            />
          </Grid>
          <Grid item xs={12}>
            <SoftTypography variant="caption" fontWeight="bold" color="text">
              Nota del documento
            </SoftTypography>
            <SoftInput
              type="text"
              name="not"
              placeholder="Ingrese una nota"
              value={formData.not}
              onChange={handleInputChange}
            />
          </Grid>
          <Grid item xs={12}>
            <DocumentTypeSelector
              selectedDocumentType={formData.tip}
              setSelectedDocumentType={(value) =>
                setFormData(prev => ({ ...prev, tip: value }))
              }
            />
          </Grid>
        </Grid>
      </Modal.Body>
      <Modal.Footer>
        <SoftButton variant="gradient" color="success" onClick={handleSave}>
          Guardar
        </SoftButton>
        <SoftButton variant="gradient" color="error" onClick={handleClose}>
          Cancelar
        </SoftButton>
      </Modal.Footer>
    </Modal>
  );
};

ShipmentEditDocumentModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  initialData: PropTypes.object,
  onRefresh: PropTypes.func,
};

ShipmentEditDocumentModal.defaultProps = {
  initialData: null,
};

export default ShipmentEditDocumentModal;
